import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FinancialTransactionReport } from '../../../models/reports/financial/transactions-report.model';

/**
 * @class DailyTransactionsPmsApiService
 * @extends {AbstractReportPmsApiService<FinancialTransactionReport>}
 */
export class DailyTransactionsPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/daily-transactions';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FinancialTransactionReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FinancialTransactionReport(attributes);
    }

    newTransactionCollection(paginationData, ...params) {

        // Handle the new API response structure
        const models = [{
            'total_row': paginationData.total_row,
            'items': paginationData.data.map(attributes => this.newModel(attributes, ...params))
        }];

        return {
            summary: paginationData.summary,
            total_row: paginationData.total_row,
            all_total_row: paginationData.all_total_row,
            perPage: paginationData.pagination.per_page,
            page: paginationData.pagination.current_page,
            total: paginationData.pagination.total,
            from: 1,
            to: paginationData.data.length,
            models: models
        };
    }

    /**
     * @param {...*} params
     * @return {function(response: Object): PaginationCollection<M>}
     * @protected
     */
    getTransactionCollector(...params) {

        return (response) => {

            const responseData = this.extractData(response);

            // Handle both old and new response structures
            if (responseData.data && Array.isArray(responseData.data)) {
                // New structure - data is directly an array
                return this.newTransactionCollection(responseData, ...params);
            } else if (responseData.data && typeof responseData.data === 'object') {
                // Old structure - data is grouped
                return this.newTransactionCollection(responseData, ...params);
            }

            return this.newTransactionCollection(responseData, ...params);
        };
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getTransactionCollector())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/daily-transactions.service.js